const intersectionOptions = {
    threshold: 0.5
}

export const observersStore = {
    observers: [],
    addObserver(el, callback) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    callback();
                    observer.unobserve(el);
                }
            });
        }, intersectionOptions);
        observer.observe(el);
        this.observers.push(observer);
    },
    clearObservers() {
        this.observers.forEach(observer => observer.disconnect());
        this.observers = [];
    }
};
